import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { GameTypeEnum } from '../store/game.types';

import { CommonGamePage } from '../components/CommonGamePage';

class _KnbGame extends Component<IRootStoreProps> {
  componentDidMount(): void {
    this.props.store.game.setDefaultParams(GameTypeEnum.KNB);
  }

  render() {
    return <CommonGamePage title={'КНБ игра'} />;
  }
}

export const KnbGamePage: WithoutStore = withStore(observer(_KnbGame));
